import scroll from "./utils/scroll";

const VideoBlock = (video: HTMLElement): void => {
  const settings = video.dataset;
  const playButton: HTMLElement = video.querySelector(".play-button");
  let player: HTMLVideoElement | HTMLIFrameElement;

  switch (settings.provider) {
    case "youtube":
      player = document.createElement("iframe");
      player.src = `https://www.youtube.com/embed/${settings.videoCode}?autoplay=1`;
      if (settings.src === "") {
        settings.src = `https://img.youtube.com/vi/${settings.videoCode}/maxresdefault.jpg`;
      }
      break;
    case "vimeo":
      player = document.createElement("iframe");
      player.src = `https://player.vimeo.com/video/${settings.videoCode}?autoplay=1`;
      if (!settings.src) {
        fetch(
          `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${settings.videoCode}`
        )
          .then((e) => e.json())
          .then((json) => {
            video.style.backgroundImage = `url(${
              json.thumbnail_url.split("_")[0]
            }_1280x720.jpg)`;
          });
      }
      break;
    default:
      player = document.createElement("video");
      player.controls = true;
      player.autoplay = true;
      player.innerHTML = `Sorry, your browser doesn't support embedded videos, but don't worry, you can <a href="${settings.videoSrc}">download it</a> and watch it with your favorite video player!`;
      player.src = settings.videoSrc;
  }

  const lightbox = document.createElement("div");
  lightbox.classList.add("video-block-lightbox");
  const closeIcon = document.createElement("i");
  closeIcon.classList.add("fal");
  closeIcon.classList.add("icon-times", "icon-invert");
  lightbox.appendChild(closeIcon);
  document.body.appendChild(lightbox);

  video.onclick = () => {
    if (settings.lightbox == "True") {
      lightbox.classList.toggle("active");
      lightbox.appendChild(player);
      scroll.lock();
    } else {
      playButton.style.display = "none";
      video.appendChild(player);
    }
  };

  if (settings.lightbox == "True") {
    closeIcon.onclick = () => {
      if (settings.provider) {
        lightbox.removeChild(lightbox.querySelector("iframe"));
      } else {
        player.pause();
      }
      lightbox.classList.toggle("active");
      scroll.unLock();
    };
  }
};

export default VideoBlock;
